import React, { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import { Button, Icon } from "aible";
import Select, { Creatable } from "react-select";
import { selectOnChangeWrapper, selectOnChangeWrapperMulti, selectOnChangeWrapperIfPresent, customMapper } from "utils/select";
import AccountSelector from "containers/Accounts/AccountSelector";
import * as foldersReducer from "containers/Folders/reducer";
import * as aiServiceReducer from "containers/AiService/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { connectionConfigSettings, isConnectionConfigFilled, isModelConfigFilled, modelConfigSettings } from "containers/AiService/config";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";
import { MODEL_TYPES } from "types/content_generation";
import { keysOf } from "utils/collect";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
function CreateTextInput({ label, sublabel, value, updateValue, placeholder, isSecret }) {
    return (React.createElement("div", { className: styles.provisionModelModalInputWrapper },
        Boolean(label || sublabel) && (React.createElement("div", { className: styles.provisionModelModalInputLabelWrapper },
            Boolean(label) && React.createElement("div", { className: styles.provisionModelModalInputLabel }, label),
            Boolean(sublabel) && React.createElement("div", { className: styles.provisionModelModalInputSublabel }, sublabel))),
        React.createElement("div", { className: styles.provisionModelModalInput },
            React.createElement(LineInput, { value: value, onChange: (x) => updateValue(x), updateInstant: true, placeholder: placeholder, isMediumBox: true, inputStyle: { fontSize: "13px", width: "100%" }, isPassword: isSecret }))));
}
function CreateInput(props) {
    if (props.isHidden) {
        return React.createElement(React.Fragment, null);
    }
    const settings = props.settings;
    if (props.options && props.isMulti) {
        /** Multiple options */
        const optionPicked = props.options.filter((o) => props.value instanceof Array ? props.value.includes(o.value) : o.value === props.value);
        const optionDefault = props.options.filter((o) => o.default === true);
        const inputValue = optionPicked.length ? optionPicked : optionDefault;
        return (React.createElement(CreateInputSelectMulti, { label: props.label, value: inputValue, updateValue: props.updateValue, options: props.options }));
    }
    else if (props.options) {
        /** Single option */
        const optionPicked = props.options.find((o) => o.value === props.value);
        const optionDefault = props.options.find((o) => o.default === true);
        const inputValue = optionPicked || optionDefault;
        return (React.createElement(CreateInputSelect, { label: props.label, value: inputValue, updateValue: props.updateValue, options: props.options }));
    }
    else if (settings !== undefined) {
        const settingKeys = keysOf(settings);
        const inputs = () => settingKeys.map((settingKey, index) => {
            const setting = settings[settingKey];
            const value = props.value?.[setting.value];
            const key = ["key", setting.value, index].join("-");
            return (React.createElement(CreateInput, { ...setting, value: value, key: key, updateValue: (v) => props.updateValue({
                    ...props.value,
                    [setting.value]: v
                }) }));
        });
        const label = props.label;
        const sublabel = props.sublabel;
        return (React.createElement("div", { style: {
                // TODO: move to css class
                marginTop: "20px",
                border: "1px solid",
                borderRadius: "3px",
                borderColor: "#dcdcdc",
                padding: "10px",
                marginLeft: "-10px",
                marginRight: "-10px"
            } },
            React.createElement("div", { className: styles.provisionModelModalInputWrapper }, Boolean(label || sublabel) && (React.createElement("div", { className: styles.provisionModelModalInputLabelWrapper },
                Boolean(label) && React.createElement("div", { className: styles.provisionModelModalInputLabel }, label),
                Boolean(sublabel) && React.createElement("div", { className: styles.provisionModelModalInputSublabel }, sublabel)))),
            inputs()));
    }
    else if ((typeof props.value === "string" || props.value === undefined) && props.options === undefined) {
        return (React.createElement(CreateTextInput, { label: props.label, sublabel: props.sublabel, value: props.value, updateValue: props.updateValue, placeholder: props.placeholder, isSecret: props.isSecret }));
    }
    return React.createElement(React.Fragment, null);
}
function CreateInputSelect({ label, sublabel, ...props }) {
    return (React.createElement("div", { className: styles.provisionModelModalInputWrapper },
        Boolean(label || sublabel) && (React.createElement("div", { className: styles.provisionModelModalInputLabelWrapper },
            Boolean(label) && React.createElement("div", { className: styles.provisionModelModalInputLabel }, label),
            Boolean(sublabel) && React.createElement("div", { className: styles.provisionModelModalInputSublabel }, sublabel))),
        React.createElement("div", { className: styles.provisionModelModalInput },
            React.createElement(Creatable, { ...props, isSearchable: true }))));
}
function CreateInputSelectMulti({ label, sublabel, value, updateValue, placeholder, options }) {
    return (React.createElement("div", { className: styles.provisionModelModalInputWrapper },
        Boolean(label || sublabel) && (React.createElement("div", { className: styles.provisionModelModalInputLabelWrapper },
            Boolean(label) && React.createElement("div", { className: styles.provisionModelModalInputLabel }, label),
            Boolean(sublabel) && React.createElement("div", { className: styles.provisionModelModalInputSublabel }, sublabel))),
        React.createElement("div", { className: styles.provisionModelModalInput },
            React.createElement(Creatable, { value: value, onChange: selectOnChangeWrapperMulti(updateValue), placeholder: placeholder, options: options, isSearchable: true, isMulti: true }))));
}
function CreateConnectionConfigurationInputs({ connectionType, connectionConfig, updateValue }) {
    const config = connectionConfigSettings[connectionType];
    const settings = config.settings;
    const settingKeys = keysOf(settings);
    const inputs = () => settingKeys.map((settingKey, index) => {
        const setting = settings[settingKey];
        const value = connectionConfig[setting.value];
        const key = ["key", config.value, setting.value, index].join("-");
        return React.createElement(CreateInput, { ...setting, value: value, key: key, updateValue: updateValue(setting.value) });
    });
    // MB: React complains about controlled/uncontrolled inputs without the keyed div.
    return React.createElement("div", { key: ["key", config.value].join("-") }, inputs());
}
function CreateModelConfigurationInputs({ modelType, modelConfig, updateValue }) {
    const config = modelConfigSettings[modelType];
    const settings = config.settings;
    const inputs = () => keysOf(settings).map((settingKey, index) => {
        const setting = settings[settingKey];
        const value = modelConfig[setting.value];
        const key = ["key", config.value, setting.value, index].join("-");
        return React.createElement(CreateInput, { ...setting, value: value, key: key, updateValue: updateValue(setting.value) });
    });
    return React.createElement("div", { key: ["key", config.value].join("-") }, inputs());
}
const CreateAIServiceConnection = ({ selectConnection }) => {
    const dispatch = useDispatch();
    const selectedAccountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const selectedFolder = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const [isCreating, updateIsCreating] = useState(false);
    const [connectionName, updateConnectionName] = useState("");
    const [connectionType, updateConnectionType] = useState(undefined);
    const [connectionConfig, updateConnectionConfig] = useState({});
    const isReadyToCreateConnection = selectedAccountId && connectionName && connectionType && isConnectionConfigFilled(connectionType, connectionConfig);
    const handleReset = () => {
        updateConnectionName("");
        updateConnectionType(undefined);
        updateIsCreating(false);
        updateConnectionConfig({});
    };
    const handleCreateConnection = () => {
        if (isReadyToCreateConnection && connectionType) {
            const [status, config] = connectionConfigSettings[connectionType].buildConfig(connectionConfig);
            if (status === "COMPLETE") {
                updateIsCreating(true);
                dispatch(aiServiceReducer.handleCreateConnection(selectedAccountId, connectionName, connectionType, config, undefined)).then((newConnection) => {
                    updateIsCreating(false);
                    if (newConnection?.id && selectConnection) {
                        selectConnection(newConnection.id);
                    }
                    handleReset();
                });
            }
        }
    };
    function handleChangeOfConnectionType(conn_type) {
        updateConnectionConfig({});
        updateConnectionType(conn_type);
    }
    const options = keysOf(connectionConfigSettings);
    const mapper = customMapper((x) => connectionConfigSettings[x].label);
    return (React.createElement("div", { className: styles.createAiServiceConnectionWrapper },
        React.createElement("div", { className: styles.provisionModelModalInputWrapper },
            React.createElement("div", { className: styles.provisionModelModalInputLabelWrapper },
                React.createElement("div", { className: styles.provisionModelModalInputLabel }, "Cloud Account")),
            React.createElement(AccountSelector, null)),
        React.createElement(CreateInputSelect, { label: "Connection Type", value: mapper.map(connectionType), onChange: selectOnChangeWrapperIfPresent((x) => handleChangeOfConnectionType(x)), placeholder: "Select Connection Type", options: mapper.mapAll(options.slice()) }),
        React.createElement(CreateInput, { label: "Connection Name", value: connectionName, updateValue: (x) => x && updateConnectionName(x), placeholder: "Connection Name" }),
        connectionType !== undefined && (React.createElement(CreateConnectionConfigurationInputs, { connectionType: connectionType, connectionConfig: connectionConfig, updateValue: (k) => (v) => {
                updateConnectionConfig({
                    ...connectionConfig,
                    [k]: v
                });
            } })),
        React.createElement("div", { className: styles.provisionModelModalInputWrapper, style: { marginTop: "20px" } },
            React.createElement(Button, { onClick: () => {
                    handleCreateConnection();
                }, type: "primary", disabled: !isReadyToCreateConnection, style: { marginLeft: "auto" }, isLoading: isCreating }, "Create Connection"))));
};
const geminiTypes = ["VERTEX_AI_GEMINI"];
const geminiModels = [
    {
        name: "Gemini 2.5 Pro",
        modelId: "gemini-2.5-pro",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        thinking: true,
        notes: "Enhanced thinking and reasoning, multimodal understanding, advanced coding, and more"
    },
    {
        name: "Gemini 2.5 Flash",
        modelId: "gemini-2.5-flash",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        thinking: true,
        notes: "Adaptive thinking, cost efficiency"
    },
    {
        name: "Gemini 2.5 Flash-Lite Preview",
        modelId: "gemini-2.5-flash-lite-preview-06-17",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        notes: "Most cost-efficient model supporting high throughput"
    },
    {
        name: "Gemini 2.0 Flash",
        modelId: "gemini-2.0-flash",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        notes: "Next generation features, speed, and realtime streaming."
    },
    {
        name: "Gemini 2.0 Flash-lite",
        modelId: "gemini-2.0-flash-lite",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        notes: "Cost efficiency and low latency"
    },
    {
        name: "text-embedding-005",
        modelId: "text-embedding-005",
        aiServiceType: "EMBEDDING"
    }
];
const openaiTypes = ["OPEN_AI"];
const openaiModels = [
    {
        name: "GPT-4.1",
        modelId: "gpt-4.1",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        notes: "Well suited for problem solving across domains."
    },
    {
        name: "GPT-4o",
        modelId: "gpt-4o",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        notes: "Fast, intelligent, flexible GPT model"
    },
    // {
    //   name: "GPT-o3-mini",
    //   modelId: "gpt-o3-mini",
    //   output: "text",
    //   thinking: true,
    //   notes: "A small model alternative to o3"
    // },
    // {
    //   name: "GPT-o3",
    //   modelId: "gpt-o3",
    //   output: "text",
    //   thinking: true,
    //   notes: "Our most powerful reasoning model"
    // },
    {
        name: "GPT-4o-mini",
        modelId: "gpt-4o-mini",
        aiServiceType: "CONTENT_GENERATION",
        output: "text",
        thinking: true,
        notes: "Faster, more affordable reasoning model"
    }
];
const AI_SERVICE_MODEL_TYPE_MAPPER = customMapper((t) => {
    switch (t) {
        case "CONTENT_GENERATION":
            return "Content Generation Model";
        case "EMBEDDING":
            return "Embeddings Model";
        case "RERANKING":
            return "Re-ranking Model";
    }
});
const BigCoTypes = [...geminiTypes, ...openaiTypes];
function getBigCoModels(connType) {
    if (geminiTypes.includes(connType)) {
        return geminiModels;
    }
    if (openaiTypes.includes(connType)) {
        return openaiModels;
    }
    return [];
}
function BigCoModels(props) {
    const dispatch = useDispatch();
    const [bigCoName, setBigCoName] = useState("");
    const [bigCoModelId, setBigCoModelId] = useState("");
    const [bigCoModelType, setBigCoModelType] = useState("CONTENT_GENERATION");
    const [isLoading, updateIsLoading] = useState({});
    async function handleCreateModel(model) {
        updateModelLoading(model.name, true);
        const create = {
            name: model.name,
            type: model.aiServiceType,
            external_id: model.modelId,
            status: "ENABLED",
            metadata: {},
            config: {
                type: "CONTENT_GENERATION",
                uri: model.modelId
            }
        };
        await dispatch(aiServiceReducer.createModel(props.connection, create));
        updateModelLoading(model.name, false);
    }
    const updateModelLoading = (modelString, val) => {
        const retLoading = {
            ...isLoading,
            [modelString]: val
        };
        updateIsLoading(retLoading);
    };
    async function handleDisableModel(model) {
        updateModelLoading(model.name, true);
        await dispatch(aiServiceReducer.disableModel(model.id));
        updateModelLoading(model.name, false);
    }
    async function handleEnableModel(model) {
        updateModelLoading(model.name, true);
        await dispatch(aiServiceReducer.enableModel(model.id));
        updateModelLoading(model.name, false);
    }
    const listModels = props.models.map((m) => {
        return (React.createElement(BigCoModelItem, { model: m, connectionId: props.connection.id, handleCreateModel: handleCreateModel, handleDisableModel: handleDisableModel, handleEnableModel: handleEnableModel, isLoading: isLoading }));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.bigCoModelProvisionContainer },
            React.createElement("p", { className: styles.guidingText }, "Easy Model Management"),
            listModels),
        React.createElement("fieldset", { className: styles.bigCoCreateModelWrapper },
            React.createElement("p", { className: styles.guidingText, style: { marginBottom: "5px" } }, "Provision a custom model"),
            React.createElement("label", { htmlFor: "bigCo-modelType", className: styles.bigCoCreateModelLabel }, "Model Type:"),
            React.createElement(Select, { id: "bigCo-modelType", value: AI_SERVICE_MODEL_TYPE_MAPPER.map(bigCoModelType), onChange: selectOnChangeWrapperIfPresent(setBigCoModelType), options: AI_SERVICE_MODEL_TYPE_MAPPER.mapAll(["CONTENT_GENERATION", "EMBEDDING"]), className: styles.bigCoCreateModelInput }),
            React.createElement("label", { htmlFor: "bigCo-name", className: styles.bigCoCreateModelLabel }, "Display Name:"),
            React.createElement("input", { id: "bigCo-name", type: "text", onChange: (e) => setBigCoName(e.target.value || ""), className: styles.bigCoCreateModelInput }),
            React.createElement("label", { htmlFor: "bigCo-modelId", className: styles.bigCoCreateModelLabel }, "Model ID:"),
            React.createElement("input", { id: "bigCo-modelId", type: "text", onChange: (e) => setBigCoModelId(e.target.value || ""), className: styles.bigCoCreateModelInput }),
            React.createElement(Button, { onClick: () => handleCreateModel({
                    name: bigCoName,
                    modelId: bigCoModelId,
                    aiServiceType: bigCoModelType,
                    output: "",
                    notes: ""
                }), isLoading: isLoading[bigCoName], isSmall: true }, "Create"))));
}
const BigCoModelItem = ({ model, connectionId, handleCreateModel, handleDisableModel: handleDisableModel, handleEnableModel: handleEnableModel, isLoading }) => {
    const aisModels = useSelector((state) => aiServiceReducer.getModels(state));
    const modelsInConnection = Object.values(aisModels).filter((m) => m.connection_id === connectionId);
    const modelInConnection = modelsInConnection.find((aisModel) => aisModel.external_id === model.modelId);
    const buttonAction = () => {
        if (modelInConnection?.status === "ENABLED") {
            return handleDisableModel(modelInConnection);
        }
        else if (modelInConnection?.status === "DISABLED") {
            return handleEnableModel(modelInConnection);
        }
        else {
            return handleCreateModel(model);
        }
    };
    const buttonText = modelInConnection?.status === "ENABLED"
        ? "Disable Model"
        : modelInConnection?.status === "DISABLED"
            ? "Enable Model"
            : "Add Model";
    return (React.createElement("div", { className: styles.provisionBigCoModelItem },
        React.createElement("div", { className: styles.provisionBigCoModelLabel }, model.name),
        React.createElement(Button, { className: styles.provisionBigCoModelButton, onClick: buttonAction, isSmall: true, isLoading: isLoading[model.name] }, buttonText)));
};
const ProvisionModelModal = ({ showModal, updateShowModal }) => {
    const dispatch = useDispatch();
    const connectionsSupportedByProvisioning = [
        "VERTEX_AI_GEMINI",
        "OPEN_AI",
        "AZURE_OPEN_AI",
        "DGX",
        "NIM_LLM"
    ];
    const aiServiceConnections = useSelector((state) => aiServiceReducer.getConnections(state));
    const aiServiceConnectionsArr = Object.values(aiServiceConnections).filter((c) => connectionsSupportedByProvisioning.includes(c.type));
    const [selectedConnectionId, updateSelectedConnectionId] = useState(aiServiceConnectionsArr?.[aiServiceConnectionsArr?.length - 1]?.id);
    const selectedAccountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const selectedConnection = selectedConnectionId ? aiServiceConnections?.[selectedConnectionId] : undefined;
    const [isCreateConnection, updateIsCreateConnection] = useState(false);
    const [isDeletingConnection, updateIsDeletingConnection] = useState(false);
    const [isCreating, updateIsCreating] = useState(false);
    const [newModelName, updateNewModelName] = useState("");
    const [newModelID, updateNewModelID] = useState("");
    const [newModelType, updateNewModelType] = useState("CONTENT_GENERATION");
    const [newModelConfig, updateNewModelConfig] = useState({});
    const aiServiceConnectionsOptions = aiServiceConnectionsArr.map((con) => {
        return {
            label: con.name,
            value: con.id
        };
    });
    const aiServiceConnectionsValue = isCreateConnection
        ? {
            label: "Create New Connection",
            value: -1
        }
        : aiServiceConnectionsOptions.find((o) => o.value === selectedConnectionId);
    const isBigCoConnection = selectedConnection?.type && BigCoTypes.includes(selectedConnection?.type);
    const handleSelectConnection = (cId) => {
        updateSelectedConnectionId(cId);
        updateIsCreateConnection(false);
    };
    const isReadyToCreateModel = !isCreateConnection &&
        selectedConnectionId &&
        newModelID &&
        newModelName &&
        newModelType &&
        isModelConfigFilled(newModelType, newModelConfig);
    const handleReset = () => {
        updateNewModelName("");
        updateNewModelID("");
        updateNewModelType("CONTENT_GENERATION");
        updateNewModelConfig({});
        updateIsCreating(false);
    };
    const handleCreateModel = () => {
        if (isReadyToCreateModel && newModelType) {
            const [status, config] = modelConfigSettings[newModelType].buildConfig({
                uri: newModelID,
                ...newModelConfig
            });
            if (status === "COMPLETE" && selectedConnection !== undefined) {
                updateIsCreating(true);
                dispatch(aiServiceReducer.handleCreateModel(selectedConnection, newModelName, newModelID, newModelType, config))
                    .then((retModel) => {
                    updateIsCreating(false);
                    if (retModel?.external_id) {
                        dispatch(chatGPTReducer.updateModelId(retModel.external_id));
                    }
                    handleReset();
                    updateShowModal(false);
                })
                    .finally(() => {
                    updateIsCreating(false);
                });
            }
        }
    };
    const handleDeleteConnection = () => {
        const currSelectedConnectionId = selectedConnectionId;
        if (currSelectedConnectionId) {
            updateIsDeletingConnection(true);
            dispatch(aiServiceReducer.handleDeleteConnection(selectedAccountId, currSelectedConnectionId)).then(() => {
                updateIsDeletingConnection(false);
                const deleteTarget = dispatch((dispatch, getState) => aiServiceReducer.getConnectionById(getState(), currSelectedConnectionId));
                if (!deleteTarget) {
                    const allConnections = dispatch((dispatch, getState) => aiServiceReducer.getConnections(getState()));
                    const allConnectionsArr = Object.values(allConnections);
                    const latestConnection = allConnectionsArr?.[allConnectionsArr?.length - 1];
                    updateSelectedConnectionId(latestConnection?.id);
                }
            });
        }
    };
    const newModelTypeOptions = AI_SERVICE_MODEL_TYPE_MAPPER.mapAll(MODEL_TYPES.slice());
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => {
            updateShowModal(false);
        } },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Provision A New AI Model")),
            React.createElement("div", { className: styles.provisionModelModalBody },
                React.createElement("div", { className: styles.provisionModelModalContentLabel }, "Where is the new model located?"),
                React.createElement("div", { className: styles.connectionSelectWrapper },
                    React.createElement("div", { className: styles.connectionSelect },
                        React.createElement(Select, { options: aiServiceConnectionsOptions, value: aiServiceConnectionsValue, onChange: selectOnChangeWrapper(handleSelectConnection), placeholder: "Select LLM Service Connection" })),
                    React.createElement("div", { className: styles.connectionSelectActions },
                        React.createElement(Button, { onClick: () => {
                                updateIsCreateConnection(!isCreateConnection);
                            }, active: isCreateConnection },
                            React.createElement(Icon, { type: "plus", size: 13, style: { marginRight: "6px" } }),
                            "Create New Connection"),
                        React.createElement(Tooltip, { overlay: "Delete Database Connection" },
                            React.createElement(Button, { type: "secondary", style: {
                                    padding: "9px",
                                    marginLeft: "10px",
                                    width: "38px",
                                    height: "38px"
                                }, onClick: handleDeleteConnection, disabled: isDeletingConnection || !selectedConnection?.permissions?.can_delete },
                                React.createElement(Icon, { type: "trash", size: 13 }))))),
                selectedConnectionId && selectedConnection && !isCreateConnection && (React.createElement("div", { className: styles.provisionModelModalInputSublabel, style: { marginTop: "6px" } },
                    React.createElement("span", null, "This connection currently has "),
                    React.createElement(Tooltip, { overlay: React.createElement("div", null, selectedConnection?.models?.map((m) => {
                            return React.createElement("div", { key: "model_" + m.id }, m?.name);
                        })), placement: "bottom" },
                        React.createElement("a", null, `${selectedConnection?.models?.length} model${selectedConnection?.models?.length === 1 ? "" : "s"}`)))),
                React.createElement("div", { className: styles.provisionModelModalContent }, isCreateConnection ? (React.createElement(CreateAIServiceConnection, { selectConnection: handleSelectConnection })) : isBigCoConnection && selectedConnection && selectedAccountId ? (React.createElement(BigCoModels, { connection: selectedConnection, models: getBigCoModels(selectedConnection.type), selectedAccountId: selectedAccountId })) : (React.createElement("div", { className: styles.createAiServiceConnectionWrapper },
                    selectedConnection?.type == "AZURE_OPEN_AI" && (React.createElement(CreateInputSelect, { label: "Model Type", value: AI_SERVICE_MODEL_TYPE_MAPPER.map(newModelType), onChange: selectOnChangeWrapperIfPresent((x) => updateNewModelType(x)), placeholder: "Select Model Type", options: newModelTypeOptions })),
                    React.createElement(CreateInput, { label: "Display Name", value: newModelName, updateValue: (x) => x && updateNewModelName(x), placeholder: "Display Name" }),
                    React.createElement(CreateInput, { label: "Model ID", value: newModelID, updateValue: (x) => x && updateNewModelID(x), placeholder: "Model ID" }),
                    newModelType && (React.createElement(CreateModelConfigurationInputs, { modelType: newModelType, modelConfig: newModelConfig, updateValue: ((k) => (v) => {
                            updateNewModelConfig({
                                ...newModelConfig,
                                [k]: v
                            });
                        }) })))))),
            React.createElement(DialogFooter, null,
                React.createElement(Tooltip, { trigger: isReadyToCreateModel || isCreating ? [] : undefined, overlay: isCreateConnection || !selectedConnectionId
                        ? "Select a connection to provision a model"
                        : "Please fill in all required fields" },
                    React.createElement(Button, { onClick: () => {
                            handleCreateModel();
                        }, type: "primary", disabled: !isReadyToCreateModel, isLoading: isCreating, hidden: isBigCoConnection }, "Provision Model"))))));
};
export default ProvisionModelModal;
